import { gql } from 'urql';
import { MonetaryAmountFragment, OwnerFragment, PersonalPropertyItemFragment } from './fragments';
import {
  ClosePersonalPropertyItemInput,
  Mutation,
  Query,
  QueryPersonalPropertyItemArgs,
  UpdatePersonalPropertyItemInput,
} from '../generated/graphql';
import { GraphQLClient } from 'graphql-request';

export const createPersonalPropertyItemMutation = gql`
  ${PersonalPropertyItemFragment}
  mutation createPersonalPropertyItem($input: CreatePersonalPropertyItemInput!) {
    createPersonalPropertyItem(input: $input) {
      personalPropertyItem {
        ...PersonalPropertyItemFragment
      }
    }
  }
`;

export const deletePersonalPropertyItemMutation = gql`
  mutation deletePersonalPropertyItem($input: DeletePersonalPropertyItemInput!) {
    deletePersonalPropertyItem(input: $input) {
      changeToken
    }
  }
`;

export const getPersonalPropertyItem = async (client: GraphQLClient, args: QueryPersonalPropertyItemArgs) => {
  return (
    await client.request<Pick<Query, 'personalPropertyItem'>>(
      gql`
        ${OwnerFragment}
        ${MonetaryAmountFragment}
        query GetPersonalPropertyItem($householdID: ID!, $id: ID!) {
          personalPropertyItem(householdID: $householdID, id: $id) {
            __typename
            id
            householdID
            name
            changeToken
            notes
            closedAt
            ownedValue {
              ...MonetaryAmountFragment
            }
            ownership {
              __typename
              ... on TenantsInCommon {
                interests {
                  owner {
                    ...OwnerFragment
                  }
                  percentage
                }
              }
            }
            value {
              tenantID
              id
              updatedAt
              latestDataPoint {
                data {
                  __typename
                  ... on MonetaryAmountDataPointValue {
                    value {
                      currencyCode
                      value
                    }
                  }
                }
              }
              dataPoints {
                items {
                  id
                  dateTime
                  data {
                    __typename
                    ... on MonetaryAmountDataPointValue {
                      value {
                        currencyCode
                        value
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `,
      {
        ...args,
      }
    )
  ).personalPropertyItem;
};

export const getPersonalPropertyItemsQuery = gql`
  ${PersonalPropertyItemFragment}
  query GetPersonalPropertyItems($householdID: ID!) {
    personalPropertyItems(householdID: $householdID) {
      items {
        ...PersonalPropertyItemFragment
      }
    }
  }
`;

export type { ClosePersonalPropertyItemInput };

export const closePersonalPropertyItemMutation = gql`
  mutation ClosePersonalPropertyItem($input: ClosePersonalPropertyItemInput!) {
    closePersonalPropertyItem(input: $input) {
      changeToken
    }
  }
`;

export const clientClosePersonalPropertyItem = async (client: GraphQLClient, input: ClosePersonalPropertyItemInput) => {
  return (
    await client.request<{ closePersonalPropertyItem: { changeToken: string } }>(closePersonalPropertyItemMutation, {
      input,
    })
  ).closePersonalPropertyItem;
};

export const mergePersonalPropertyItemsMutation = gql`
  mutation MergePersonalPropertyItems($input: MergePersonalPropertyItemsInput!) {
    mergePersonalPropertyItems(input: $input) {
      merged
    }
  }
`;

const updatePersonalPropertyItemMutation = gql`
  ${PersonalPropertyItemFragment}
  mutation UpdatePersonalPropertyItem($input: UpdatePersonalPropertyItemInput!) {
    updatePersonalPropertyItem(input: $input) {
      personalPropertyItem {
        ...PersonalPropertyItemFragment
      }
    }
  }
`;

export const clientUpdatePersonalPropertyItem = async (
  client: GraphQLClient,
  input: UpdatePersonalPropertyItemInput
) => {
  return (
    await client.request<Pick<Mutation, 'updatePersonalPropertyItem'>>(updatePersonalPropertyItemMutation, {
      input,
    })
  ).updatePersonalPropertyItem;
};
